import { acme, acmeMarketingHeadlineSx, acmeMarketingBodyLeadSx } from "../../theme/acmeTheme";

export const authPageOuterSx = {
  minHeight: "100vh",
  width: "100%",
  display: { xs: "flex", lg: "grid" },
  gridTemplateColumns: { lg: "1fr 1fr" },
  backgroundColor: acme.colors.background,
  overflow: { md: "hidden" },
};

export const authHeroColumnSx = {
  display: { xs: "none", lg: "flex" },
  flexDirection: "column",
  position: "relative",
  height: "100%",
  minHeight: "100vh",
  p: 5,
  borderRight: `1px solid ${acme.colors.border}`,
  backgroundColor: "#0a0a0a",
  overflow: "hidden",
};

export const authHeroGradientSx = {
  position: "absolute",
  inset: 0,
  zIndex: 1,
  background: "linear-gradient(to top, #0a0a0a 0%, transparent 45%)",
  pointerEvents: "none",
};

export const authHeroBrandSx = {
  position: "relative",
  zIndex: 2,
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const authHeroQuoteSx = {
  position: "relative",
  zIndex: 2,
  mt: "auto",
};

export const authFormColumnSx = {
  position: "relative",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  p: { xs: 2, sm: 3, md: 4 },
  backgroundColor: acme.colors.background,
};

export const authFormRadialSx = {
  position: "absolute",
  inset: 0,
  zIndex: 0,
  pointerEvents: "none",
  opacity: 0.6,
  isolation: "isolate",
  overflow: "hidden",
};

export const authFormInnerSx = {
  position: "relative",
  zIndex: 1,
  width: "100%",
  maxWidth: 384,
  mx: "auto",
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const authCenterOuterSx = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  p: { xs: 2, sm: 3 },
  boxSizing: "border-box",
  backgroundColor: acme.colors.background,
};

export const authCenterCardSx = {
  width: "100%",
  maxWidth: 440,
  borderRadius: acme.radius.lg,
  border: `1px solid ${acme.colors.border}`,
  boxShadow: "none",
  backgroundColor: acme.colors.background,
  p: { xs: 3, sm: 4 },
};

export const authTitleSx = {
  ...acmeMarketingHeadlineSx,
  fontSize: { xs: "1.5rem", sm: "1.625rem" },
  color: acme.colors.foreground,
};

export const authSubtitleSx = {
  ...acmeMarketingBodyLeadSx,
  color: acme.colors.mutedForegroundSolid,
  fontSize: "0.9375rem",
  mt: 0.5,
};

export const authHomeButtonSx = {
  position: "absolute",
  top: { xs: 20, sm: 28 },
  left: { xs: 12, sm: 20 },
  zIndex: 2,
  color: acme.colors.mutedForegroundSolid,
  fontSize: "0.875rem",
  px: 1.5,
  "&:hover": {
    backgroundColor: acme.colors.muted,
    color: acme.colors.foreground,
  },
};

export const authLegalTextSx = {
  mt: 2,
  fontSize: "0.8125rem",
  color: acme.colors.mutedForegroundSolid,
  lineHeight: 1.6,
  "& a": {
    color: "inherit",
    textDecoration: "underline",
    textUnderlineOffset: 3,
    "&:hover": { color: acme.colors.foreground },
  },
};
